import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Instagram, MapPin, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return null;
  }

  const handleMapClick = () => {
    window.open('https://maps.app.goo.gl/ePhjMgw2xwxFtRRJ9', '_blank');
  };

  return (
    <footer data-testid="main-footer" className="bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="font-heading text-xl mb-4">Estel Regals</h3>
            <p className="text-sm text-primary-foreground/80">
              Després de gairebé 50 anys de servei al barri de Pedralbes, ens seguim esforçant per dur novetats i solucions creatives per a les necessitats dels nostres clients. A la nostra botiga hi trobaràs tot el que busques o bé t'ho cercarem!
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl mb-4">Enllaços</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm hover:underline">
                Inici
              </Link>
              <Link to="/catalog" className="text-sm hover:underline">
                Catàleg
              </Link>
              <Link to="/terms" className="text-sm hover:underline">
                Termes i Condicions
              </Link>
              <Link to="/privacy" className="text-sm hover:underline">
                Política de Privacitat
              </Link>
              <Link to="/cookies" className="text-sm hover:underline">
                Política de Cookies
              </Link>
            </nav>
          </div>

          <div>
            <h3 className="font-heading text-xl mb-4">Contacte</h3>
            <div className="space-y-3 text-sm text-primary-foreground/80">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div>
                  Carrer Capità Arenas, 25, Baixos<br />
                  08034 Barcelona
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <a href="tel:+34932040216" className="hover:underline">
                  932 040 216
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Instagram className="h-4 w-4 flex-shrink-0" />
                <a 
                  href="https://www.instagram.com/terestel/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:underline"
                >
                  @terestel
                </a>
              </div>
            </div>
            <Button
              onClick={handleMapClick}
              data-testid="map-button"
              className="mt-4 w-full"
              variant="secondary"
            >
              <MapPin className="h-4 w-4 mr-2" />
              Com arribar
            </Button>
          </div>

          <div>
            <h3 className="font-heading text-xl mb-4">Membres de</h3>
            <a 
              href="https://mirallpedralbes.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block"
            >
              <div className="bg-white rounded-xl p-6 hover:shadow-lg transition-all">
                <img 
                  src="/assets/mirall-pedralbes.jpeg"
                  alt="Mirall de Pedralbes"
                  className="w-full h-auto"
                />
                <p className="text-xs text-center mt-3 text-foreground font-medium">
                  Associació de Comerços
                </p>
              </div>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20 text-center text-sm text-primary-foreground/60">
          <p>© {new Date().getFullYear()} Estel Regals. Tots els drets reservats.</p>
          <p className="mt-2">
            Projecte by{' '}
            <a 
              href="https://digitalsunriselabs.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-bold text-primary-foreground/80 hover:text-primary-foreground transition-colors"
            >
              Digital Sunrise Labs®
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;